import type { ScheduleItem } from 'owa-graph-schema';
import { getGuid } from 'owa-guid';

const SEPARATOR = '#';

// This function appends a random GUID to the item ID of ScheduleItems from GetSchedule
// in order to make them unique for use as React element keys. This is necessary since
// these item IDs are immutable, will not change between queries the same way that
// they do when retrieved from GetUserAvailabilityInternal, and may be undefined if
// the reader doesn't have sufficient permissions to the remote calendar.
export function updateScheduleItemIdsForCache(items: ScheduleItem[]): void {
    items.forEach(item => {
        item.id = `${item.id}${SEPARATOR}${getGuid()}`;
    });
}

export function getScheduleItemIdFromCacheItemId(itemId: string): string {
    return itemId.split(SEPARATOR)[0];
}
